export default __webpack_public_path__ + "images/0xbc45647ea894030a4e9801ec03479739fa2485f0.png";